import React from 'react';
import { Spinner } from 'reactstrap';

export default function CustomButtonLoader(){
    return(
        <Spinner color="light" size="sm" />
    );
}